import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-close.svg";
import * as styles from "./Icon.module.scss";

type CloseProps = React.SVGProps<SVGSVGElement>;

export const Close = ({ className, ...props }: CloseProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
